import PropTypes from 'prop-types';
import React from 'react';
import { Popover } from 'sabre-spark-react';
import { Popover as SparkPopover } from '@sabre/aven-spark';
import classnames from 'classnames';
import { hasParent } from '../../../../../lib/utils';

/**
 * Helper class to allow popover nesting
 */
class SparkPopoverEx extends SparkPopover {
    constructor(el, options, nestedPopovers = []) {
        super(el, options);
        this.nestedPopovers = nestedPopovers;
    }

    _onWindowClick(e) {
        if (
            this.nestedPopovers.every(
                nested =>
                    !nested ||
                    (nested &&
                        nested._sparkInstance &&
                        e.target !== nested._sparkInstance.contentEl &&
                        e.target !== nested._sparkInstance.el &&
                        !hasParent(e.target, nested._sparkInstance.el) &&
                        !hasParent(e.target, nested._sparkInstance.contentEl))
            )
        ) {
            super._onWindowClick(e);
        }
    }
}

export default class PopoverEx extends Popover {
    static propTypes = {
        className: PropTypes.string,
        nestedPopovers: PropTypes.arrayOf(PropTypes.element),
        isDisabled: PropTypes.bool
    };
    componentDidMount() {
        const { anchorX, anchorY, onOpen, onClose, toggleEl, isDisabled } = this.props;
        this._sparkInstance =
            !isDisabled &&
            new SparkPopoverEx(
                this._container,
                { anchorX, anchorY, onOpen, onClose, toggleEl },
                this.props.nestedPopovers
            );
    }

    componentWillUnmount() {
        this._sparkInstance = undefined;
    }
    render() {
        return (
            <div ref={el => (this._container = el)} className="spark-popover">
                {this.props.toggleEl}
                <div className={classnames('spark-popover__content', this.props.className)} role="tooltip">
                    {this.props.children}
                    <span className="spark-popover__caret"></span>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/ui/sabre-spark-react-ex/popover/popover.js